import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { UserPermissionError } from '../../common/utils/errors';
import { getCreateGoalGraphqlPayload, getCreateGoalURL } from './utils';
export var createGoal = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _response$errors, _response$data;
    var name, cloudId, _ref$gatewayBaseUrl, gatewayBaseUrl, ownerId, goalTypeAri, targetDate, parentGoalAri, request, response, _err$extensions, _response$errors2, err, unableToFindUserMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          name = _ref.name, cloudId = _ref.cloudId, _ref$gatewayBaseUrl = _ref.gatewayBaseUrl, gatewayBaseUrl = _ref$gatewayBaseUrl === void 0 ? '' : _ref$gatewayBaseUrl, ownerId = _ref.ownerId, goalTypeAri = _ref.goalTypeAri, targetDate = _ref.targetDate, parentGoalAri = _ref.parentGoalAri;
          _context.next = 3;
          return fetch(getCreateGoalURL({
            gatewayBaseUrl: gatewayBaseUrl
          }), {
            method: 'post',
            credentials: 'include',
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: getCreateGoalGraphqlPayload({
              name: name,
              cloudId: cloudId,
              ownerId: ownerId,
              goalTypeAri: goalTypeAri,
              targetDate: targetDate !== null && targetDate !== void 0 && targetDate.date ? "targetDate: {date: \"".concat(targetDate.date.end, "\", confidence: ").concat(targetDate.confidence, "}") : '',
              parentGoalAri: parentGoalAri
            })
          });
        case 3:
          request = _context.sent;
          _context.next = 6;
          return request.json();
        case 6:
          response = _context.sent;
          if (!(((_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : _response$errors.length) > 0)) {
            _context.next = 15;
            break;
          }
          _response$errors2 = _slicedToArray(response.errors, 1), err = _response$errors2[0]; // Grab the first error
          unableToFindUserMessage = (err === null || err === void 0 ? void 0 : err.message).includes('Unable to find user');
          if (!((err === null || err === void 0 || (_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.statusCode) === 403 || unableToFindUserMessage)) {
            _context.next = 14;
            break;
          }
          throw new UserPermissionError('The user does not have the required permission for this action.');
        case 14:
          throw new Error('Error creating a new goal');
        case 15:
          return _context.abrupt("return", response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.townsquare) === null || _response$data === void 0 || (_response$data = _response$data.createGoal) === null || _response$data === void 0 ? void 0 : _response$data.goal);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createGoal(_x) {
    return _ref2.apply(this, arguments);
  };
}();